"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FhirResourceType = exports.FhirClientType = void 0;
var FhirClientType;
(function (FhirClientType) {
    FhirClientType[FhirClientType["UTAH_USER_DSTU2"] = 'utah-user-dstu2'] = "UTAH_USER_DSTU2";
    FhirClientType[FhirClientType["UTAH_USER_R4"] = 'utah-user-r4'] = "UTAH_USER_R4";
    FhirClientType[FhirClientType["UTAH_SYSTEM_DSTU2"] = 'utah-system-dstu2'] = "UTAH_SYSTEM_DSTU2";
    FhirClientType[FhirClientType["UTAH_SYSTEM_R4"] = 'utah-system-r4'] = "UTAH_SYSTEM_R4";
})(FhirClientType || (exports.FhirClientType = FhirClientType = {}));
var FhirResourceType;
(function (FhirResourceType) {
    FhirResourceType["ALLERGY_INTOLERANCE"] = "AllergyIntolerance";
    FhirResourceType["APPOINTMENT"] = "Appointment";
    FhirResourceType["BINARY"] = "Binary";
    FhirResourceType["CARE_PLAN"] = "CarePlan";
    FhirResourceType["CONDITION"] = "Condition";
    FhirResourceType["CONTRACT"] = "Contract";
    FhirResourceType["DIAGNOSTIC_REPORT"] = "DiagnosticReport";
    FhirResourceType["DOCUMENT_REFERENCE"] = "DocumentReference";
    FhirResourceType["ENCOUNTER"] = "Encounter";
    FhirResourceType["GOAL"] = "Goal";
    FhirResourceType["IMMUNIZATION"] = "Immunization";
    FhirResourceType["MEDICATION_ORDER"] = "MedicationOrder";
    FhirResourceType["MEDICATION_REQUEST"] = "MedicationRequest";
    FhirResourceType["MEDICATION_STATEMENT"] = "MedicationStatement";
    FhirResourceType["OBSERVATION"] = "Observation";
    FhirResourceType["PATIENT"] = "Patient";
    FhirResourceType["PERSON"] = "Person";
    FhirResourceType["PROCEDURE"] = "Procedure";
    FhirResourceType["RELATED_PERSON"] = "RelatedPerson";
    FhirResourceType["SCHEDULE"] = "Schedule";
    FhirResourceType["SLOT"] = "Slot";
})(FhirResourceType || (exports.FhirResourceType = FhirResourceType = {}));
//# sourceMappingURL=fhir.js.map